import { render, staticRenderFns } from "./o-product-card.vue?vue&type=template&id=6dab1518&"
import script from "./o-product-card.vue?vue&type=script&lang=js&"
export * from "./o-product-card.vue?vue&type=script&lang=js&"
import style0 from "./o-product-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports